import { Component, Input } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { LaudoUnionService } from "./../../../../services/http/laudo-union.service";

@Component({
  selector: "app-form-realizar-consulta-laudo",
  templateUrl: "./form-realizar-consulta-laudo.component.html",
  styleUrls: ["./form-realizar-consulta-laudo.component.scss"],
})
export class FormRealizarConsultaLaudoComponent {
  constructor(
    private _laudoUnionService: LaudoUnionService,
    private _msgService: ModalMsgService
  ) {}

  @Input() modal: NgbActiveModal;
  @Input() tokenLaudo: string;
  @Input() placa: string;

  form = new FormGroup({
    id: new FormControl("", Validators.required),
  });

  desejaResgatar: boolean = false;
  stateOptions: any[] = [
    { label: "Não", desejaResgatar: false },
    { label: "Sim", desejaResgatar: true },
  ];

  funcDesejaResgatar() {
    this.desejaResgatar = this.desejaResgatar;
  }

  fecharModal() {
    this.modal.close(null);
  }

  async realizarConsulta() {
    if (this.desejaResgatar) {
      var erro: boolean = false;
      var mensagem: string = "Falha ao realizar a operação.";
      await this._laudoUnionService
        .inserirConsultaPeloIdResgate(this.form.value.id, this.tokenLaudo)
        .then((response) => {
          erro = response?.map?.erro;
          mensagem = response?.map?.mensagem;
        })
        .catch((error) => {
          erro = true;
        });

      await this._msgService.open(
        erro ? "Erro" : "Sucesso",
        mensagem,
        erro ? "danger" : "success",
        null,
        { text: "Fechar", btnClass: "btn-info" },
        { hidden: true },
        true
      );
    }

    this.modal.close(this.desejaResgatar);
  }
}
